import React from 'react';
import { motion } from 'framer-motion';
export function FAQ() {
  const items = [{
    q: '¿Qué incluye el diagnóstico de mi sitio web?',
    a: 'Recibirás el ICD™ de tu sitio web con puntuación en las cinco dimensiones, las tres brechas más críticas, recomendaciones específicas y un comparativo con el promedio de tu sector.'
  }, {
    q: '¿Cuánto tarda el diagnóstico?',
    a: 'El diagnóstico de tu sitio web se entrega en 48 horas hábiles. Lo analiza personalmente el equipo de Origen Studio. No es un reporte automático.'
  }, {
    q: '¿Tiene algún costo?',
    a: 'El diagnóstico inicial es completamente gratuito. Sin compromiso de contratación y sin reunión previa.'
  }, {
    q: '¿Necesito una reunión para recibirlo?',
    a: 'No. Completas el formulario y en 48 horas recibes el análisis en tu correo. Si quieres revisar los resultados juntos podemos agendar una llamada, pero no es un requisito.'
  }, {
    q: '¿Cómo evalúan el sitio web?',
    a: 'Evaluamos tu sitio web en cinco dimensiones con criterios objetivos y verificables: Credibilidad, Claridad, Conversión, Autoridad y Rendimiento. Cada dimensión vale 20 puntos sobre 100. Los criterios son técnicos y medibles, no opiniones de diseño.'
  }, {
    q: '¿Qué pasa después del diagnóstico?',
    a: 'Recibes el análisis completo de tu sitio web. Si quieres entender cómo corregimos las brechas construyendo o rediseñando tu sitio, podemos agendar una llamada de 30 minutos. Sin presión, sin compromiso adicional.'
  }];
  return <section className="bg-arena pt-[72px] md:pt-[120px] pb-[120px]" data-id="element-176">
      <div className="max-w-[1200px] mx-auto px-6 md:px-20" data-id="element-177">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="mb-12 md:mb-16" data-id="element-178">
          <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-widest mb-4" data-id="element-179">
            PREGUNTAS FRECUENTES
          </span>
          <h2 className="font-display text-[32px] md:text-[40px] font-bold text-carbon leading-[1.1] max-w-[560px]" data-id="element-180">
            Todo lo que necesitas saber antes de solicitar el diagnóstico.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-2" data-id="element-181">
          {items.map((item, idx) => <motion.div key={idx} className="py-6 border-t border-carbon/10" initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          ease: 'easeOut',
          delay: idx * 0.05
        }} data-id="element-182">
              <h3 className="font-display text-[18px] font-semibold text-carbon mb-3" data-id="element-183">
                {item.q}
              </h3>
              <p className="font-body text-[16px] text-carbon/65 leading-[1.65]" data-id="element-184">
                {item.a}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}